export default "__VITE_ASSET__a34680c8__"